import {
	SMALL_DEVICE_WIDTH_MAX,
	MEDIUM_PORTRAIT_WIDTH_MAX,
	MEDIUM_DEVICE_WIDTH_MAX,
	LARGE_DEVICE_WIDTH_MAX,
} from "@/common/consts";

export default {
	namespaced: true,
	state: {
		windowHeight: null,
		windowWidth: null,
		scrollY: null,
		/*
			This is the pixel height between the top of the window and
			the bottom of the header. I.e., if the header is scrolled out of view, this value is 0.
			*/
		visibleHeaderHeight: null,
		topAdHeight: 0,
		headerHeight: 0,
		searchHeaderMobileHeight: 0,
	},
	actions: {},
	mutations: {
		UPDATE_WINDOW_PROPERTIES: function(state, payload) {
			state.windowHeight = payload.windowHeight;
			state.windowWidth = payload.windowWidth;
		},
		UPDATE_WINDOW_SCROLL: function(state, value) {
			state.scrollY = value;
		},
		UPDATE_VISIBLE_HEADER_HEIGHT: function(state, value) {
			state.visibleHeaderHeight = value;
		},
		SET_HEADER_HEIGHT: function(state, value) {
			state.headerHeight = value;
		},
		SET_TOP_AD_HEIGHT: function(state, value) {
			state.topAdHeight = value;
		},
		SET_SEARCH_HEADER_MOBILE_HEIGHT: function(state, value) {
			state.searchHeaderMobileHeight = value;
		},
	},
	getters: {
		isSmallDevice: (state) => {
			return (
				state.windowWidth !== null &&
				state.windowWidth <= SMALL_DEVICE_WIDTH_MAX
			);
		},
		isMediumPortraitDevice(state) {
			return (
				state.windowWidth !== null &&
				state.windowWidth <= MEDIUM_PORTRAIT_WIDTH_MAX &&
				state.windowWidth > SMALL_DEVICE_WIDTH_MAX
			);
		},
		isMediumDevice(state) {
			return (
				state.windowWidth !== null &&
				state.windowWidth <= MEDIUM_DEVICE_WIDTH_MAX &&
				state.windowWidth > SMALL_DEVICE_WIDTH_MAX
			);
		},
		isSmallOrMediumPortraitDevice(state, getters) {
			return getters.isSmallDevice || getters.isMediumPortraitDevice;
		},
		isSmallOrMediumDevice(state, getters) {
			return getters.isSmallDevice || getters.isMediumDevice;
		},
		isLargeDevice(state, getters) {
			return (
				!getters.isSmallOrMediumDevice &&
				state.windowWidth !== null &&
				state.windowWidth <= LARGE_DEVICE_WIDTH_MAX
			);
		},
		isExtraLargeDevice(state) {
			return (
				state.windowWidth !== null &&
				state.windowWidth > LARGE_DEVICE_WIDTH_MAX
			);
		},
		isMediumDeviceOrWider(state, getters) {
			return state.windowWidth !== null && !getters.isSmallDevice;
		},
		isMediumLandscapeDeviceOrWider(state, getters) {
			return (
				state.windowWidth !== null &&
				!getters.isSmallOrMediumPortraitDevice
			);
		},
		isLargeDeviceOrWider(state) {
			return (
				state.windowWidth !== null &&
				state.windowWidth > MEDIUM_DEVICE_WIDTH_MAX
			);
		},
	},
};
